module.exports = __webpack_public_path__ + "assets/Logo.41b4af6704ca1466e8512d4a563ac61dfce8431b3d51f72fe6969e587a2afc75.png";